var t = function t() {
  this.head = null, this.tail = null;
};
t.prototype = {
  add: function add(t) {
    var i = {
        item: t,
        next: null
      },
      e = this.tail;
    e ? e.next = i : this.head = i, this.tail = i;
  },
  get: function get() {
    var t = this.head;
    if (t) return null === (this.head = t.next) && (this.tail = null), t.item;
  }
};
var i = t;
export { i as q };